import React from 'react'
import { cn } from 'src/enviroment/lib/utils'
import { Button, ButtonProps } from './Button'

interface GradientBorderButtonProps extends Omit<ButtonProps, 'size'> {
  className?: string
  children: React.ReactNode
  gradientSize?: 'sm' | 'md' | 'lg'
  textSize?: 'xs' | 'sm' | 'base'
  iconOnly?: boolean
}

const sizeClasses = {
  sm: 'h-10 px-4 text-sm',
  md: 'h-12 px-6 text-base',
  lg: 'h-14 px-8 text-base',
}

const iconSizeClasses = {
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-12 w-12',
}

const textSizeClasses = {
  xs: 'text-xs',
  sm: 'text-sm',
  base: 'text-base',
}

export function GradientBorderButton({
  className,
  children,
  gradientSize = 'md',
  textSize = 'base',
  iconOnly = false,
  ...props
}: GradientBorderButtonProps) {
  return (
    <Button
      variant="ghost"
      className={cn(
        'group relative rounded-full border-0 p-0 ',
        iconOnly ? iconSizeClasses[gradientSize] : sizeClasses[gradientSize],
        className,
      )}
      style={{
        background: `
          linear-gradient(#27292C, #27292C) padding-box,
          linear-gradient(216deg, #329175 -32.48%, #F5F5DC 132.11%) border-box
        `,
        border: '1px solid transparent',
      }}
      {...props}
    >
      <span className="absolute inset-0 rounded-full bg-black/20 opacity-0 transition-opacity group-hover:opacity-100" />
      <div
        className={cn(
          'relative flex items-center justify-center gap-2 font-inter text-base text-gray-50',
          textSizeClasses[textSize],
        )}
      >
        {children}
      </div>
    </Button>
  )
}
